import { Icon, Link, Clamp, Highlight } from 'components/common';
import ActivityIcon from './ActivityIcon';
import { Container } from '../styled';
import { colours } from 'utils/theme';
import { format } from 'utils/date';
import {
  InnerContainerRow,
  ActivityData,
  ActivityTitle,
  ActivityDetail,
  ContentWrapper,
  MetadataLabel,
  IconWrapper,
  MetadataValue,
} from './styled';
import OwnersDetails from './OwnersDetail';

const Tradeshow = ({
  sciLeadsPosterId,
  show,
  title,
  sessionType,
  date,
  sessionStartDate,
  highlights,
  researchers,
  organisations,
  city,
  state,
  country,
  isVirtual,
}) => {
  let location = [city, state, country]
    .map(s => s && s.trim())
    .filter(Boolean)
    .join(', ');

  let dateLabel =
    sessionStartDate && sessionStartDate !== '0001-01-01T00:00:00'
      ? 'Session Date:'
      : 'Tradeshow Date:';
  return (
    <Container>
      <InnerContainerRow>
        <IconWrapper>
          <Icon color={colours.posters} size='1x' icon='image' />
        </IconWrapper>
        <ContentWrapper>
          <Link to={`poster/${sciLeadsPosterId}`} showIconHint>
            <ActivityTitle>
              <Clamp text={title} />
            </ActivityTitle>
          </Link>

          <ActivityDetail>
            <Highlight highlights={highlights} />
            <InnerContainerRow>
              <ActivityData>
                <MetadataLabel>
                  <ActivityIcon icon='calendar' />
                  {dateLabel}
                </MetadataLabel>
                <MetadataValue>
                  {format(date, 'D MMM YYYY', 'Not Available')}
                </MetadataValue>
              </ActivityData>
              <ActivityData>
                <MetadataLabel>
                  <ActivityIcon icon='image' />
                  Show:
                </MetadataLabel>
                <MetadataValue>{show}</MetadataValue>
              </ActivityData>
              <ActivityData>
                <MetadataLabel>
                  <ActivityIcon icon='image' />
                  Session Type:
                </MetadataLabel>
                <MetadataValue>{sessionType}</MetadataValue>
              </ActivityData>
            </InnerContainerRow>
            <InnerContainerRow>
              {location && (
                <ActivityData>
                  <MetadataLabel>
                    <ActivityIcon icon='map' />
                    Location:
                  </MetadataLabel>
                  <MetadataValue>{location}</MetadataValue>
                </ActivityData>
              )}
              {!!isVirtual && (
                <ActivityData>
                  <MetadataLabel>
                    <ActivityIcon icon='video' />
                    Virtual
                  </MetadataLabel>
                </ActivityData>
              )}
            </InnerContainerRow>
          </ActivityDetail>
          <OwnersDetails
            researchers={researchers}
            organisations={organisations}
          />
        </ContentWrapper>
      </InnerContainerRow>
    </Container>
  );
};

export default Tradeshow;
